import styled from "styled-components";
import {gridSize, smallScreenThreshold} from "../style-variables";

export const Page = styled.div`
  line-height: 2;
  margin: 0 auto;
  width: ${gridSize * 34}px; 
    @media screen and (max-width: ${smallScreenThreshold}) {  
        padding: 0 ${gridSize *1}px;
        width: auto;
    }
  }
`;
